import * as React from "react";
import { CoreConstants } from "../../../../core/models/constants/core.constants";

const PriorityTemplate = (priority: number) => {
  if (priority) {
    switch (priority) {
      case CoreConstants.Priority.one.value:
        return (
          <div className="inline-block py-0.5 px-2 text-xs font-semibold text-red-500 border border-red-500 rounded-md ">
            {CoreConstants.Priority.one.label}
          </div>
        );
      case CoreConstants.Priority.two.value:
        return (
          <div className="inline-block py-0.5 px-2 text-xs font-semibold text-yellow-500 border border-yellow-500 rounded-md ">
            {CoreConstants.Priority.two.label}
          </div>
        );
      case CoreConstants.Priority.three.value:
        return (
          <div className="inline-block px-2 text-xs py-0.5 font-semibold text-green-500 border border-green-500 rounded-md ">
            {CoreConstants.Priority.three.label}
          </div>
        );
    }
  }
};

export default PriorityTemplate;
